<template>
  <div class="delete">
    <common-header
      is-passport
      :show-back="!isSDK"
      :show-lang="false"
      :title="languages.apple_deleteaccount"
      class="mb-0"
    ></common-header>
    <iframe
      class="delete-content"
      :title="languages.apple_deleteaccount"
      :src="accountDeleteHref"
    ></iframe>
  </div>
</template>
<script>
import globalConfig from '@utiles/globalConfig';
import commonHeader from '@/resource/components/support/header';
import { isFn } from '../../utiles/judgeType';
import bridge from '@utiles/bridge';
const isBuild = process.env.NODE_ENV === 'production';
const mainHost = globalConfig.getMainHost();
const isH5 = globalConfig.getHrefParam('h5') === '1';
export default {
  data() {
    return {
      isBackLogout: false
    };
  },
  computed: {
    languages() {
      return this.$store.state.passport.languages;
    },
    accountDeleteHref() {
      const realFile = isBuild
        ? `//gabres.${mainHost}/platform`
        : `//gabres-test.${mainHost}`;
      return `${realFile}/officialSupport.html${window.location.search}&isOldPassport=1&isInPassport=1#/accountdelete?source=oldPassportPage`;
    },
    isSDK() {
      let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
      let isWeb = +globalConfig.getHrefParam('web') === 1;
      return hasSdkToken || (isWeb && +isH5);
    }
  },
  mounted() {
    globalConfig.addEvenListener(this.sdklistenerFn, 'message');
  },
  deactivated() {
    if (this.isBackLogout) {
      if (isH5) {
        this.logout();
        return;
      }
      if (bridge.runInsdk()) {
        bridge.callSdkMethod('logout', {});
      }
    }
  },
  methods: {
    sdklistenerFn(e) {
      var evt = e || event;
      var data = evt.data;
      if (this.judgeIsSameMainHost(evt.origin, window.location.origin)) {
        if (data.method && isFn(this[data.method])) {
          try {
            this[data.method](data.params);
          } catch (e) {
            console.log(e);
          }
        }
      }
    },
    judgeIsSameMainHost(h1, h2) {
      let h1MainHostMatch = h1.match(/.\w*.\w*$/);
      let h2MainHostMatch = h2.match(/.\w*.\w*$/);
      if (
        h1MainHostMatch &&
        h2MainHostMatch &&
        h1MainHostMatch[0] &&
        h2MainHostMatch[0]
      ) {
        return h1MainHostMatch[0] == h2MainHostMatch[0];
      } else {
      }
    },
    logout() {
      window.parent.postMessage(
        {
          method: 'logout'
        },
        window.location.origin
      );
    },
    backLogout() {
      this.isBackLogout = true;
    }
  },
  components: {
    commonHeader
  }
};
</script>

<style lang="scss" scoped>
$paddingTop: 60px;

.delete {
  position: relative;
  box-sizing: border-box;
  height: calc(100vh - $paddingTop);
  &-content {
    display: block;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
}
.mb-0 {
  margin-bottom: 0 !important;
}

::v-deep .page-main {
  padding: $paddingTop 0 0 0 !important;
}

@media screen and (orientation: landscape) {
  ::v-deep .page-main {
    max-width: unset !important;
  }
}
</style>
